// Copyright © 2025 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import React, { Fragment, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import {
  withStyles,
} from '@material-ui/core';
import { get } from 'lodash';
import { string, object, func, bool } from 'prop-types';

import styles from './styles';
import { getI18n } from '../../../../utils/intl';
import { OverviewPaperWithStatus } from './Paper';
import { PROXY_KEYS_QUERY_PARAMS } from '../../../../constants';


export const DETAILS_URL = '/admin/key-stores/details/';

export const AppApiKeys = (props) => {
  const {
    uuid,
    keyStoreDetailsKeyCounts,
    push,
    keyStoreDetails,
    onDeployment,
    refreshTime,
    checkStatus,
  } = props;

  const intl = getI18n(useIntl());
  const noData = intl.getI18nMessage('label.key.store.no.data');
  const [publishedCount, setPublishedCount] = useState(noData);
  const [pendingCount, setPendingCount] = useState(noData);
  const [deployedCount, setDeployedCount] = useState(noData);
  const [errorCount, setErrorCount] = useState(noData);
  const [notDeployedCount, setNotDeployedCount] = useState(noData);
  const [keyStoreCount, setKeyStoreCount] = useState(noData);

  useEffect(() => {
    if(uuid) {
      setPublishedCount(get(keyStoreDetailsKeyCounts, 'portalApiKeyCount') || 0 );
      setPendingCount(get(keyStoreDetailsKeyCounts, 'pendingApiKeyDeploymentCount') || 0);
      setDeployedCount(get(keyStoreDetailsKeyCounts, 'deployedApiKeyCount') || 0);
      setErrorCount(get(keyStoreDetailsKeyCounts, 'errorApiKeyDeploymentCount') || 0);
      setNotDeployedCount(get(keyStoreDetailsKeyCounts, 'notDeployedApiKeyCount') || 0);
      setKeyStoreCount(get(keyStoreDetailsKeyCounts, 'keyStoreApiKeyCount') || 0);
    }
  }, [keyStoreDetailsKeyCounts]);

  return (
    <Fragment>
      <OverviewPaperWithStatus
        id="keys"
        title={intl.getI18nMessage('label.application.api.keys')}
        status={get(keyStoreDetails, 'connectionStatus')}
        notDeployedCount ={notDeployedCount}
        publishedCount={publishedCount}
        pendingCount={pendingCount}
        deployedCount={deployedCount}
        errorCount={errorCount}
        keyStoreCount={keyStoreCount}
        linkUrl={`${DETAILS_URL}${uuid}/key-deployments`}
        push={push}
        queryParams={PROXY_KEYS_QUERY_PARAMS}
        deploymentType={get(keyStoreDetails, 'deploymentType')}
        onDeployment={onDeployment}
        refreshTime={refreshTime}
        checkStatus={checkStatus}
        bulkDeploymentStatus={get(keyStoreDetailsKeyCounts, 'bulkDeploymentStatus')}
        keyStoreType={get(keyStoreDetails, 'keyStoreType')}
      />
    </Fragment>
  );
};

const mapStateToProps = () => ({

});

AppApiKeys.propTypes = {
  uuid: string,
  keyStoreDetailsKeyCounts: object,
  keyStoreDetails: object,
  push: func,
  onDeployment: func,
  refreshTime: func,
  checkStatus: func,
  isBulkDeploymentStatusRunning: bool,
};
AppApiKeys.displayName = 'AppApiKeys';

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(AppApiKeys);
